// extracted by mini-css-extract-plugin
export default {"marqueeWrapper":"pXQmjc","vetsNegativeWrapper":"RA00D_","vetsPositiveWrapper":"iTUaN5"};